import { BgColorPalette } from '@/constants';
import { AccountPlan } from '@/constants/enum';
import styled from 'styled-components';

export const StyledUpgradeLock = styled.div<{ $usedFeature: AccountPlan }>`
  .badge-activator {
    background-color: ${BgColorPalette.BADGE_INFO_BG};
    color: ${BgColorPalette.BADGE_INFO_COLOR};
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    padding: 0.05rem 0.5rem;
    border-radius: 0.75rem;
    cursor: pointer;
    margin-left: 0.25rem;
  }
`;
